import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { Box } from '@mui/material';
import { Lan } from '@mui/icons-material';
import { AccordionHeader } from './accordion-header';
import { AccordionWithValidation } from 'console/device-settings/z3k/components/material-utils/accordion-with-validation';
import { TypographyWithCopy } from 'console/shared/components/fields';
import { selectDevice } from 'entities/device/lib';
import { Z3KSettings } from 'console/device-settings/z3k/provider/types';
export function EthernetBodyComponent({ ethernet_state, }) {
    return (_jsxs(Box, { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gridTemplateRows: "repeat(auto-fill, minmax(50px, 1fr))", gap: 2, children: [_jsx(TypographyWithCopy, { label: "IP", value: ethernet_state.ip, show_copy: true }), _jsx(TypographyWithCopy, { label: "MAC", value: ethernet_state.mac, show_copy: true }), _jsx(TypographyWithCopy, { label: "\u041C\u0430\u0441\u043A\u0430 \u043F\u043E\u0434\u0441\u0435\u0442\u0438", value: ethernet_state.mask }), _jsx(TypographyWithCopy, { label: "\u0428\u043B\u044E\u0437", value: ethernet_state.gate })] }));
}
export function EthernetSettings() {
    const { device_id } = useContext(Z3KSettings);
    const device = usePartialAppSelector(selectDevice, device_id);
    if (device == null) {
        return null;
    }
    const { ethernet_state, online } = device;
    if (ethernet_state == null) {
        return null;
    }
    return (_jsx(AccordionWithValidation, { header: _jsx(AccordionHeader, { icon: _jsx(Lan, {}), heading: "Ethernet", subheading: ethernet_state.is_connected && online
                ? `подключен, ${ethernet_state.ip}`
                : 'нет соединения' }), validation_result: null, validation_warnings_result: null, children: _jsx(EthernetBodyComponent, { ethernet_state: ethernet_state }) }));
}
